import * as React from "react";
import { makeStyles, Field } from "@fluentui/react-components";
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 600,
    textAlign: "left",
    width: "100%",
    color: "#4E4E4E"
  },
});

export const FluentField = ({
  label,
  size,
  disabled,
  validationMessage,
  required,
  children,
  componentStyle
}) => {
  const styles = useStyles();

  return (
    <Field
      label={label}
      size={size}
      validationMessage={validationMessage}
      disabled={disabled}
      required={required}
      className={`${componentStyle || ""} ${styles.root}`}
    >
      {children}
    </Field>
  );
};

FluentField.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node,
  size: PropTypes.string,
  componentStyle: PropTypes.string,
};